const SDK_VERSION = '8.22.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
